import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge50 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='記名式会員権とは' fontWeight={700} />
                <p>
                    記名式ゴルフ会員権とは、会員権の名義に特定の個人（または法人が指定した特定の担当者）が登録され、その本人しかプレーできない会員権のことです。個人会員のゴルフ会員権は基本的にすべて記名式で、法人会員権にも「記名式」と、法人に属する人であれば誰でも利用できる
                    <a href='/knowledge/24'>無記名式ゴルフ会員権</a>
                    の2種類があります。
                    <br />
                    本記事では、記名式ゴルフ会員権の種類やメリット・デメリット、無記名式との違いについて詳しく解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='記名式の種類' fontWeight={700} />

                <Heading3 title='1名記名式' />
                <p>
                    会員権に1名のみが記名されている、最も一般的な形態です。個人会員はすべてこの1名記名式にあたります。法人が保有する場合も、担当者を1名だけ記名して運用するケースがあります。
                </p>

                <Heading3 title='複数名記名式（法人会員権）' />
                <p>
                    法人会員権の中には、2名・3名など複数人を記名できる形態があります。記名された人物であれば誰でもプレーが可能で、1名記名式に比べると利用できる人の幅が広がりますが、その分、購入料金も記名人数に応じて高くなる傾向があります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='記名式ゴルフ会員権のメリット・デメリット' fontWeight={700} />

                <Heading3 title='メリット：無記名式より購入料金が抑えられる' />
                <p>
                    記名式は無記名式に比べて発行しているゴルフ場が多く、選択肢が豊富です。また、同じゴルフ場であれば無記名式より購入料金が安く設定されていることが一般的で、1名記名式であれば個人会員と同等の料金で取得できます。
                </p>

                <Heading3 title='デメリット：利用者を変更するたびに名義書換が必要' />
                <p>
                    記名されている本人以外はプレーできないため、担当者が異動・退職した場合はそのつど名義書換の手続きと費用が発生します。法人で頻繁に担当者が入れ替わる場合は、都度の名義書換料が負担になりやすい点に注意が必要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='記名式から無記名式へ変更できるか' fontWeight={700} />
                <p>
                    記名式から無記名式への変更を希望されるケースもありますが、無記名式を新規に発行しているゴルフ場自体が非常に限られているため、現実的には難しい場合がほとんどです。
                    <br />
                    逆に、無記名式会員権を売買や譲渡で名義書換する際に記名式へ変更されることは一般的です。無記名式が減少した背景や現存する発行ゴルフ場については
                    <a href='/knowledge/24'>無記名式ゴルフ会員権とは？記名式との違いやメリット・デメリットを解説</a>
                    で詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    記名式ゴルフ会員権は、特定の個人しか利用できない分、無記名式より購入料金を抑えやすく、発行しているゴルフ場の選択肢も豊富です。一方で、法人利用の場合は担当者が変わるたびに名義書換の手続きが必要になる点を踏まえて検討しましょう。
                    <br />
                    法人でゴルフ会員権を持つ際の記名式・無記名式の使い分けについては
                    <a href='/knowledge/14'>法人のゴルフ会員権とは？記名式と無記名式の違いについても解説</a>
                    もあわせてご確認ください。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge50;
